// Central de Creditos: situacao do prazo de hab/div de um caso (cards e painel do caso).
const PHASES = {
    open: { text: "Prazo aberto", tone: "success" },
    closed: { text: "Prazo encerrado", tone: "neutral" },
    not_started: { text: "Prazo não iniciado", tone: "info" },
    none: { text: "Sem prazo cadastrado", tone: "warning" },
};

export function formatCaseDate(value) {
    return value ? String(value).slice(0, 10).split("-").reverse().join("/") : "";
}

// { text, tone, hint } a partir do resumo do caso (habdiv: status e datas).
export function habdivPhase(habdiv = {}) {
    // Fase finalizada na aba "Cadastro da verificacao": encerrada mesmo dentro do prazo.
    if (habdiv.finished) {
        const when = habdiv.finished_at ? ` em ${formatCaseDate(habdiv.finished_at)}` : "";
        return { text: "Fase finalizada", tone: "neutral", hint: `finalizada${when}` };
    }
    const base = PHASES[habdiv.status] || PHASES.none;
    let hint = "Cadastre o prazo na aba Cadastro da verificação";
    if (habdiv.status === "open") hint = `até ${formatCaseDate(habdiv.end_date)}`;
    if (habdiv.status === "closed") hint = `encerrado em ${formatCaseDate(habdiv.end_date)}`;
    if (habdiv.status === "not_started") hint = `começa em ${formatCaseDate(habdiv.start_date)}`;
    if (habdiv.legal_date) hint += ` · legal ${formatCaseDate(habdiv.legal_date)}`;
    return { ...base, hint };
}
